import React, { useRef, useState, useImperativeHandle } from "react";
import ModalView from '@/components/modal-view'
import styled from "styled-components";
import ModalBG from '../imgs/modal-bg@2x.png';

const CommonModal = React.forwardRef((_, ref) => {
  const [showModal, setShowModal] = useState(false);

  const modalContent = useRef(null);
  const openTypeRef = useRef(null);

  useImperativeHandle(ref, () => {
    return {
      show: (content, type) => {
        modalContent.current = content;
        setShowModal(true);
        openTypeRef.current = type;
      },
      close: () => setShowModal(false),
      updateModal: (data) => {
        if (showModal) {
          if (openTypeRef.current === 'authRealPerson' && data.authRealPerson !== 0) {
            setShowModal(false);
          }
          if (openTypeRef.current === 'alipayBound' && data.alipayBound !== 0) {
            setShowModal(false);
          }
        }
      }
    }
  });

  return (
    <ModalView
      visible={showModal}
      onClose={() => setShowModal(false)}
      content={
        <ModalWrap>
          <div className="modal-content">
            <div className="modal-bg-wrap">
              <img id="modal-bg" className="modal-bg" src={ModalBG} alt='' />
            </div>
            {modalContent.current}
          </div>
        </ModalWrap>
      }
    />
  )
})

const ModalWrap = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 27px;
  color: #333;
  .modal-content {
    position: relative;
    background: linear-gradient(180deg, #FFE7E1 0%, #FFFFFF 100%);
    border-radius: 10px;
    padding: 49px 0 17px;
  }
  .modal-bg-wrap {
    position: absolute;
    left: 0;
    top: -73px;
    width: 100%;
    display: flex;
    justify-content: center;
    .modal-bg {
      width: 189px;
      height: 132px;
    }
  }
  
`

export default React.memo(CommonModal);




// WEBPACK FOOTER //
// ./src/views/activity_42/components/common-modal.js